<template>
	<div class="users">
		Поиск по пользователям
		<inputi/>
		<list-select :options="[{label:'по ИД', value:'_id'}]"/>
		<icheckbox label="По ID" v-model="search_by" :value="_id"/>
		<icheckbox label="По email" v-model="search_by" :value="email"/>
		<icheckbox label="По телефону" v-model="search_by" :value="phone"/>
		<btn label='Поиск' i='search' t='s'/>
	</div>
</template>

<script>
export default {
  name: 'users',
  data () {
    return {
    	search_by:'_id'
    }
  }
}
</script>

<style lang="css" scoped>
</style>